<template>
  <div class=""
  >
    <transition
        enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
        enter-class="translate-x-full"
        enter-to-class="translate-x-0"
        leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
        leave-class="translate-x-0"
        leave-to-class="translate-x-full">
      <div v-if="show" class="fixed inset-0 overflow-hidden z-10">
        <div class="absolute inset-0 overflow-hidden"
             @click="closeModal">
          <section  :class="width"
                    class="absolute inset-y-0 right-0 pl-10 flex sm:pl-16 mt-20 ">
            <!--
              Slide-over panel, show/hide based on slide-over state.

              Entering: "transform transition ease-in-out duration-500 sm:duration-700"
                From: "translate-x-full"
                To: "translate-x-0"
              Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
                From: "translate-x-0"
                To: "translate-x-full"
            -->
            <div class="w-full">
              <div    class="h-full flex flex-col space-y-6 py-6 bg-white shadow-xl overflow-y-scroll"
                      ref="modalContainer"
                      @scroll="updateScroll"
                      @click="cancelClose">
                <header class="px-4 sm:px-6">
                  <div class="flex items-start justify-between space-x-3">
                    <div class="w-full pb-5 border-b border-gray-200 space-y-2">
                      <p class="text-lg leading-6 font-medium text-gray-900">
                        <slot name="title">

                        </slot>
                      </p>
                      <p class="text-xl leading-5 text-gray-500 items-center justify-center flex w-full">
                        <slot name="title-content">
                        </slot>
                      </p>
                    </div>
                    <div class="h-7 flex items-center">
                      <button
                          @click.stop="closeModal"
                          aria-label="Close panel"
                          class="text-gray-400 hover:text-gray-500">
                        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </header>
                <div class="relative flex-1 px-4 sm:px-6">
                  <!-- Replace with your content -->
                  <div class="absolute inset-0 px-4 sm:px-6">
                    <slot name="content">

                    </slot>
                  </div>
                  <!-- /End replace -->
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SlideOverPanelWide",
  props:{
    show: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: 'w-4/5 2xl:w-2/3',
    },
    scrollToY: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      shouldClose: true,
    }
  },
  methods: {
    cancelClose() {
      this.shouldClose = false
      setTimeout(() => {
        this.shouldClose = true
      }, 100)
    },
    closeModal() {
      if (!this.shouldClose) {
        return
      }
      setTimeout(() => {
        if (this.shouldClose) {
          this.$emit('update:show', false)
        }
      }, 10)
    },

    updateScroll(ev) {
      this.$emit('update:scrollToY', 1)
    }
  },
  watch: {
    show() {
      if (!this.shouldClose) {
        this.$emit('update:show', true)
      }
    },
    scrollToY() {
      this.$refs.modalContainer.scrollTo(0, this.scrollToY)
      this.$emit('update:scrollToY', 1)
    },
  },
}
</script>

<style scoped>

</style>